/**
 * MatterActivityPane — what has happened to this matter.
 *
 * The audit log used to be a hand-rolled `fixed inset-y-0 right-0 w-96` drawer
 * with its own black backdrop, opened from the overflow menu and living
 * outside every layout the page had. It is the same content the batch-table
 * detail already renders through `AuditLogPanel`, so this pane reuses that
 * component rather than keeping a second copy of the drawer alive.
 *
 * COLLABORATORS LEFT. They were pinned above the log in a non-scrolling
 * header, with their own avatar/name/badge row anatomy and their own "Manage"
 * button, so seeing who is on a matter meant loading its whole audit history —
 * and the roster was the one part of the pane that could not scroll. Access is
 * its own pane now, on the shared `AccessPane`; see `surface/layout`.
 */

import React from 'react';
import AuditLogPanel from '../../AuditLog/AuditLogPanel';

interface Props {
  matterId: string;
  matterName: string;
  onClose: () => void;
}

const MatterActivityPane: React.FC<Props> = ({ matterId, matterName, onClose }) => (
  <div className="flex flex-col h-full min-h-0">
    {/* No `hideHeader`: the log reads `useInPane()` and renders its body
        alone inside a pane, which already has a header and a close button.
        See `shared/surface/PaneBody`. */}
    <AuditLogPanel
      entityType="matter"
      entityId={matterId}
      entityName={matterName}
      onClose={onClose}
    />
  </div>
);

export default MatterActivityPane;
